import React, { useState } from 'react';
import '../styling/playername.css';
import { Navigate, useNavigate } from 'react-router-dom';

export default function Playername() {
    const navigate = useNavigate();
    const [name, setname] = useState('');
    const submitHandler = (e) => {
        e.preventDefault();
        localStorage.setItem('user_exam_name', name);
        navigate('/exam');
    }
    return (
        <>
            {localStorage.getItem(`${localStorage.getItem('oponent_userid')}`) ? <Navigate to='/score' /> :
                <div className='start'>
                    <div className="stwap">
                        <div className="inlab namest">write your name</div>
                        <div className='nameinput'>
                            <form className='nameform' onSubmit={submitHandler} >
                                <input className='name' type="text" value={name} onChange={(e) => setname(e.target.value)} /> <br />
                                <input className='stbtn namesub' type="submit" value="Next" />
                            </form>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
